var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('div',{staticClass:"settings"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"settings-wrap"},[_c('personal-data'),_c('contact-data'),_c('address-data'),_c('sync-social'),_c('change-password')],1)])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }